import { render, staticRenderFns } from "./HandballArena.vue?vue&type=template&id=609700fe&scoped=true"
import script from "./HandballArena.vue?vue&type=script&lang=js"
export * from "./HandballArena.vue?vue&type=script&lang=js"
import style0 from "./HandballArena.vue?vue&type=style&index=0&id=609700fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609700fe",
  null
  
)

export default component.exports